import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nestedProperty',
  standalone: true
})
export class NestedPropertyPipe implements PipeTransform {
  transform(data: any, accessPath: string): any {
    if (!data || !accessPath) return null;

    return (
      accessPath
        .replace(/\[(\d+)]/g, '.$1') // Convert [0] to .0 for easier splitting
        .split('.')
        .reduce((acc, key) => acc && acc[key], data) ?? null
    );
  }
}
